import React, {useEffect, useState} from 'react';
import ReactHTMLTableToExcel from 'react-html-table-to-excel';
import DrawTable from '../../components/DrawTable';
import api from '../../core/api';
import moment from 'moment';

const ButtonExport = ({
  filterValue,
  customerSize,
  clientType,
  clientStatus,
  contractDate,
  contractValidityDate,
  numericFilter,
}) => {
  const [dataExport, setDataExport] = useState([]);

  async function fetchUsers() {
    try {
      const filters = {
        filterValue,
        customerSize,
        clientType,
        clientStatus,
        contractDate,
        contractValidityDate,
        numericFilter,
      };

      const {data} = await api.get('business', {
        params: {
          filters,
        },
      });

      const dataEx = data?.map(business => {
        const businessFormatted = {
          clientCode: business?.clientCode,
          tradeName: business?.tradeName,
          corporateName: business?.corporateName,
          clientDocument: business?.clientDocument,
          customerSize: business?.customerSize,
          complement: business?.complement,
          neighborhood: business?.neighborhood,
          city: business?.city,
          state: business?.state,
          clientType: business?.clientType,
          activityBranch: business?.activityBranch,
          site: business?.site,
          midia_1: business?.midia_1,
          midia_2: business?.midia_2,
          midia_3: business?.midia_3,
          midia_4: business?.midia_4,
          contractStatus: business?.contractStatus,
          clientStatus: business?.clientStatus,

          // management
          is_branch: business?.is_branch ? 'Sim' : 'Não',
          belongs_to_group: business?.belongs_to_group ? 'Sim' : 'Não',
          contractValidityDate: business?.contractValidityDate || '-',
          startDate: business.business_commercials[0]?.invoiceIssueDate || '-',
          valueFull: business?.business_commercials[0]?.valueFull || '-',
          status: business?.business_commercials[0]?.status || '-',
          validity: business.business_commercials[0]?.validity
            ? moment
                .utc(business?.business_commercials[0]?.validity)
                .format('DD/MM/YYYY')
            : '-',
          planDate: business.business_commercials[0]?.planDate
            ? moment
                .utc(business?.business_commercials[0]?.planDate)
                .format('DD/MM/YYYY')
            : '-',
          paymentMethod:
            business?.business_commercials[0]?.paymentMethod || '-',
          billingType: business?.business_commercials[0]?.billingType || '-',
          invoiceIssueDate:
            business.business_commercials[0]?.invoiceIssueDate || '-',
          dueDate: business.business_commercials[0]?.dueDate || '-',
        };
        return businessFormatted;
      });
      // console.log('dataEx', dataEx);
      setDataExport(dataEx);
    } catch (err) {
    } finally {
    }
  }

  useEffect(() => {
    fetchUsers();
  }, [
    filterValue,
    customerSize,
    clientType,
    clientStatus,
    contractDate,
    contractValidityDate,
    numericFilter,
  ]);

  return (
    <>
      <div style={{marginLeft: 10}} />
      <ReactHTMLTableToExcel
        id="partners-table-xls-button"
        table="business-to-xls"
        className="MuiButtonBase-root MuiButton-root MuiButton-contained"
        filename={`relatorio_cadastral_ de_empresas_${new Date()}`}
        sheet="tablexls"
        buttonText="RELATÓRIO CADASTRAL EMPRESAS"
      />
      <div style={{marginLeft: 10}} />
      <ReactHTMLTableToExcel
        id="partners-table-xls-button"
        table="management-to-xls"
        className="MuiButtonBase-root MuiButton-root MuiButton-contained"
        filename={`relatorio_de_gestao_de_contratos_${new Date()}`}
        sheet="tablexls"
        buttonText="RELATÓRIO DE GESTÃO DE CONTRATOS"
      />

      <div style={{visibility: 'hidden', height: 10, width: '100%'}}>
        {DrawTable(
          [
            'Código cliente',
            'Nome Fantasia',
            'Razão Social / Nome Completo',
            'CNPJ ou CPF',
            'Porte do Cliente',
            'Bairro',
            'Cidade',
            'Estado',
            'Tipo de cliente',
            'Ramo de Atividade',
            'Site',
            'Midia social 1',
            'Midia social 2',
            'Midia social 3',
            'Midia social 4',
            'Status do Contrato',
            'Status do Cliente',
          ],
          dataExport.map(business => [
            business.clientCode,
            business.tradeName,
            business.corporateName,
            business.clientDocument,
            business.customerSize,
            business.neighborhood,
            business.city,
            business.state,
            business.clientType,
            business.activityBranch,
            business.site,
            business.midia_1,
            business.midia_2,
            business.midia_3,
            business.midia_4,
            business.contractStatus,
            business.clientStatus,
          ]),
          'business-to-xls',
        )}
      </div>
      <div style={{visibility: 'hidden', height: 10, width: '100%'}}>
        {DrawTable(
          [
            'Código cliente',
            'Nome Fantasia',
            'Razão Social / Nome Completo',
            'CNPJ ou CPF',
            'Porte do Cliente',
            'Cidade',
            'Estado',
            'Tipo de cliente',
            'Empresa filial',
            'Empresa pertencente agrupo',
            'Status do Contrato',
            'Vigência do Contrato',
            'Status do cliente',
            'Data de início do Plano',
            'Valor contratado',
            'Data de vigência',
            'Forma de pagamento',
            'Tipo de faturamento',
            'Data para emissão de NF',
            'Data de vencimento',
          ],
          dataExport.map(business => [
            business.clientCode,
            business.tradeName,
            business.corporateName,
            business.clientDocument,
            business.customerSize,
            business.city,
            business.state,
            business.clientType,
            business.is_branch,
            business.belongs_to_group,
            business.contractStatus,
            business.contractValidityDate,
            business.clientStatus,
            business.startDate,
            business.valueFull,
            business.validity,
            business.planDate,
            business.paymentMethod,
            business.billingType,
            business.invoiceIssueDate,
            business.dueDate,
          ]),
          'management-to-xls',
        )}
      </div>
    </>
  );
};

export default ButtonExport;
